import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-points-chart',
  templateUrl: './points-chart.component.html',
  styleUrls: ['./points-chart.component.css']
})
export class PointsChartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
